/**
 * Navigation helpers shared by Ops AI surfaces.
 *
 * Create with AI can send the user to BOQ & drawings mid-proposal, so every hop
 * carries a returnTo that lands back on the Task Template tab with the AI drawer
 * reopened (draft is restored from opsAiDraftStore).
 */

import { navigateWithReturn } from '../../../shared/navigation';

export const BOQ_BOM_PATH = '/builder/operations/boq-bom';
export const TASK_MANAGEMENT_PATH = '/builder/operations/task-management';

/** Current Ops page as a refresh-safe returnTo that reopens the AI drawer. */
export function buildOpsAiReturnTo(location, projectId, { openAiChat = true } = {}) {
  const pathname = location?.pathname || TASK_MANAGEMENT_PATH;
  const params = new URLSearchParams(location?.search || '');
  params.delete('returnTo');
  if (openAiChat) params.set('aiChat', '1');
  if (pathname.includes('/task-management')) params.set('tab', 'taskTemplate');
  if (projectId) params.set('project_id', String(projectId));
  const qs = params.toString();
  return qs ? `${pathname}?${qs}` : pathname;
}

/** Open BOQ & drawings for a project, keeping the way back to the AI proposal. */
export function openBoqWithReturn(navigate, location, projectId, { openAiChat = true } = {}) {
  const params = new URLSearchParams();
  if (projectId) params.set('project_id', String(projectId));
  params.set('fromAi', '1');
  const qs = params.toString();

  navigateWithReturn(navigate, qs ? `${BOQ_BOM_PATH}?${qs}` : BOQ_BOM_PATH, {
    returnTo: buildOpsAiReturnTo(location, projectId, { openAiChat }),
    state: { projectID: projectId ? Number(projectId) : null, fromAiTemplate: true }
  });
}
